import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取客户列表
export function customerList(query) {
    return axios({
        url: "/admin/index/userlist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 验证 客户ID /设备ID /项目ID 是否唯一
export function isVerificationID(type,query) {
    var url = 
        type == 'KH'
            ? "/admin/index/username" + API_SUFFIX 
            : type == 'XM'
                ? "/admin/index/item_number" + API_SUFFIX
                : type == 'SB'
                    ? "/admin/index/device_id" + API_SUFFIX
                    : ''
    return axios({
        url: url,
        method: "get",
        params: query
    });
}

// 新增客户
export function apiUseradd(data, method = "post") {
    return axios({
        url: "/admin/index/useradd" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 获取巡查/维保团队信息
export function apiGetTeam(query) {
    return axios({
        url: "/admin/index/team" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 获取 客户+项目+设备详情
export function apiSetailsList(query) {
    return axios({
        url: "/admin/index/userdetails" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 查询客户所有项目
export function apiProjectList(query) {
    return axios({
        url: "/admin/index/projectlist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 查询客户所有项目
export function apiProjectdist(query) {
    return axios({
        url: "/admin/index/projectdist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 新增项目（查询客户信息）
export function apiProjectadd(query) {
    return axios({
        url: "/admin/index/projectadd" + API_SUFFIX,
        method: "get",
        params: query
    });
}


// 新增项目（提交）
export function apiProjectaddSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/projectadd" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 获取 设备详情
export function apiEquipmentdata(query) {
    return axios({
        url: "/admin/index/equipmentdata" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 设备开关
export function apiEquipmentSwitch(query) {
    return axios({
        url: "/admin/index/e_switch" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 获取 安装信息 / 维保信息 / 巡查信息
export function apiAllTasklistData(type,query) {
    var url = 
        type == 'install'
            ? "/admin/index/a_tasklist" + API_SUFFIX 
            : type == 'maintenance'
                ? "/admin/index/w_tasklist" + API_SUFFIX
                : type == 'patrol'
                    ? "/admin/index/x_tasklist" + API_SUFFIX
                    : ''
    return axios({
        url: url,
        method: "get",
        params: query
    });
}

// 获取 安装信息详情 / 维保信息详情 / 巡查信息详情
export function apiAllTaskdetailsData(type,query) {
    var url = 
        type == 'install'
            ? "/admin/index/a_taskdetails" + API_SUFFIX 
            : type == 'maintenance'
                ? "/admin/index/w_taskdetails" + API_SUFFIX
                : type == 'patrol'
                    ? "/admin/index/x_taskdetails" + API_SUFFIX
                    : ''
    return axios({
        url: url,
        method: "get",
        params: query
    });
}

// 新增维修任务（查询客户/项目资料）
export function apiAddWTask(query) {
    return axios({
        url: "/admin/index/addw_task" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 新增维修任务查项目底下所有设备
export function apiEquipmentlist(query) {
    return axios({
        url: "/admin/index/equipmentlist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 验证维保任务编号是否存在
export function apiOrder(query) {
    return axios({
        url: "/admin/index/order" + API_SUFFIX,
        method: "get",
        params: query
    });
}


// 新增维修任务（提交）
export function apiAddWTaskPost(data, method = "post") {
    return axios({
        url: "/admin/index/addw_tasksssss" + API_SUFFIX,
        // url: "/admin/index/addw_task" + API_SUFFIX,
        method: method,
        data: data,
        // header: {
        //     'Content-Type': 'application/json'
        // },
    });
}


// 新增设备（查询客户/项目信息）
export function apiAddEquipment(query) {
    return axios({
        url: "/admin/index/add_equipment" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 新增设备（提交）
export function apiAddEquipmentSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/add_equipment" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 查询所有维保团队
export function apiReplaceWteam(query) {
    return axios({
        url: "/admin/index/replace_wteam" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 更换维保团队（提交）
export function apiReplaceWteamSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/replace_wteam" + API_SUFFIX,
        method: method,
        data: data
    });
}



// 查询所有巡查团队
export function apiReplaceXteam(query) {
    return axios({
        url: "/admin/index/replace_xteam" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 更换巡查团队（提交）
export function apiReplaceXteamSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/replace_xteam" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 编辑客户 
export function apiUseredit(query) {
    return axios({
        url: "/admin/index/useredit" + API_SUFFIX,
        method: "get",
        params: query
    });
}
//编辑客户（提交）
export function apiUsereditSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/useredit" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 编辑项目
export function apiProjectedit(query) {
    return axios({
        url: "/admin/index/projectedit" + API_SUFFIX,
        method: "get",
        params: query
    });
}
//编辑客户（提交）
export function apiProjecteditSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/projectedit" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 编辑设备
export function apiEquipmentEdit(query) {
    return axios({
        url: "/admin/index/equipment_edit" + API_SUFFIX,
        method: "get",
        params: query
    });
}
//编辑客户（提交）
export function apiEquipmentEditSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/equipment_edit" + API_SUFFIX,
        method: method,
        data: data
    });
}

//保存设备现场图片（提交）
export function apiEimgXianchang(data, method = "post") {
    return axios({
        url: "/admin/index/eimg_xianchang" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 水质记录列表
export function apiEditWaterIndicators(query) {
    return axios({
        url: "/admin/index/waterloglist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 编辑水质记录
export function apiEditWaterIndicatorsTime(query) {
    return axios({
        url: "/admin/index/editwaterlog" + API_SUFFIX,
        method: "get",
        params: query
    });
}


//水质记录 保存
export function waterIndicatorsSave(data, formName, method = "post") {
    var url =
        formName === "add"
            ? "/admin/index/addwaterlog" + API_SUFFIX
            : "/admin/index/editwaterlog" + API_SUFFIX;
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// 删除
export function waterIndicatorsDelete(data) {
    return axios({
        url: "/admin/index/deletetwaterlog" + API_SUFFIX,
        method: "post",
        data: data
    });
}
